"use strict";
//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var variables_1 = require("./variables");
/**
 * The primary export of the theme, including both raw variables and opinionated
 * color aliases using the color theme variables.
 */
var theme = __assign(__assign({}, variables_1.default), { colors: __assign(__assign({}, variables_1.default.colors), { aliases: {
            primary: variables_1.default.colors.teal1,
            primaryShade1: variables_1.default.colors.teal2,
            primaryShade2: variables_1.default.colors.teal3,
            secondary: variables_1.default.colors.purple1,
            secondaryShade1: variables_1.default.colors.purple2,
            secondaryShade2: variables_1.default.colors.purple3,
            success: variables_1.default.colors.green8,
            error: variables_1.default.colors.red8,
            warning: variables_1.default.colors.yellow5,
            focus: variables_1.default.colors.cyan8,
            disabled: variables_1.default.colors.gray4,
            new: variables_1.default.colors.mint5,
            bodyPrimary: variables_1.default.colors.gray9,
            bodySecondary: variables_1.default.colors.gray7,
        } }) });
exports.default = theme;
